import { Component } from '@angular/core';

@Component({
    selector: 'app-tiles-info',
    templateUrl: './tiles-info.component.html',
    styleUrls: ['./tiles-info.component.scss'],
    standalone: false
})
export class TilesInfoComponent {
    public infoBullets = [
        { id: 1 },
        { id: 2 },
        { id: 3 }
    ];
}
